export const LOAD_CARRIERS_FOR_CONFIGURATION = 'LOAD_CARRIERS_FOR_CONFIGURATION';
export const LOAD_PROPERTY_VALUES_FOR_CONFIGURATION = 'LOAD_PROPERTY_VALUES_FOR_CONFIGURATION';
export const RESET_CARRIERS_PROPERTY_VALUES_FOR_CONFIGURATION = 'RESET_CARRIERS_PROPERTY_VALUES_FOR_CONFIGURATION';
export const ADD_NEW_CONFIGURATION = 'ADD_NEW_CONFIGURATION';
export const EDIT_CONFIGURATION = 'EDIT_CONFIGURATION';
export const UPDATE_TRANSLATE_CONFIGURATION = 'UPDATE_TRANSLATE_CONFIGURATION';
export const LOAD_EDITABLE_CONFIGURATION = 'LOAD_EDITABLE_CONFIGURATION';
export const LOAD_CONFIGURATIONS = 'LOAD_CONFIGURATIONS';
export const SET_CONFIGURATION_PAGINATION = 'SET_CONFIGURATION_PAGINATION';
export const SET_CONFIGURATION_FILTER = 'SET_CONFIGURATION_FILTER';
export const SET_CONFIGURATION_SORT = 'SET_CONFIGURATION_SORT';
export const LOAD_CARRIERS_FOR_CONFIGURATION_FILTER = 'LOAD_CARRIERS_FOR_CONFIGURATION_FILTER';
export const LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER = 'LOAD_PROPERTY_VALUES_FOR_CONFIGURATION_FILTER';
export const RESET_CONFIGURATION_FILTERS = 'RESET_CONFIGURATION_FILTERS';
export const TOGGLE_CONFIGURATION_STATUS = 'TOGGLE_CONFIGURATION_STATUS';
export const SET_CHECKED_CONFIGURATIONS = 'SET_CHECKED_CONFIGURATIONS';
export const BULK_CHECKED_CONFIGURATIONS = 'BULK_CHECKED_CONFIGURATIONS';
export const ADD_BULK_CONFIGURATIONS = 'ADD_BULK_CONFIGURATIONS';
export const UPDATE_PROGRESS_OF_BULK_CONFIGURATIONS = 'UPDATE_PROGRESS_OF_BULK_CONFIGURATIONS';
export const FINISH_ADDING_BULK_CONFIGURATIONS = 'FINISH_ADDING_BULK_CONFIGURATIONS';
export const RESET_BULK_CONFIGURATIONS = 'RESET_BULK_CONFIGURATIONS';
